import { render, staticRenderFns } from "./FeaturesZigzag.vue?vue&type=template&id=436dc148&"
import script from "./FeaturesZigzag.vue?vue&type=script&lang=js&"
export * from "./FeaturesZigzag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports